import React from 'react';

import {Markdown} from '../../../components/utils/md/markdown';
import {EditHoc} from '../../../components/edit-hoc';
import {MonsterQuery, TraitSpellLine} from '../../../generated/types';
import {formatMonsterTraitText} from '../../../components/render-helpers';

import css from './trait.module.css';

type Props = {
	id?: string;
	title: string;
	description: string;
	availSpells?: TraitSpellLine[] | null;
	monster: MonsterQuery['monster'];
};

export const MonsterTrait: React.FC<Props> = ({description, title, monster, availSpells, id}) => {
	let result = `*_${title}._* ${formatMonsterTraitText(description)}`;

	if (availSpells) {
		const lines: string[] = [];
		availSpells.forEach((spellLine) => {
			let line = `${spellLine.slots === 'i' ? 'Неограниченно' : `${spellLine.slots} в день`}`;
			if (spellLine.isEach) line += ' каждое';
			const spells = [...spellLine.spells].sort((s1, s2) => (s1.title > s2.title ? 1 : -1));
			lines.push(`*${line}:* ${spells.map((spell) => `{@spell ${spell.id}, ${spell.title}}${spell.comment ? ` (${spell.comment})` : ''}`).join(', ')}`);
		});

		result += `[indent]${lines.join('\n')}[/indent]`;
	}

	if (id)
		return (
			<EditHoc
				load={() => import('../edit-buttons/edit-monster-trait').then((m) => m.EditMonsterTrait)}
				editProps={{id, monsterId: monster.id!}}
			>
				<div className={css.trait}>
					<Markdown text={result} />
				</div>
			</EditHoc>
		);
	return (
		<div className={css.trait}>
			<Markdown text={result} />
		</div>
	);
};
